import * as _throttle from 'lodash/throttle';
import * as _set from 'lodash/set';
import Store from '@/store/';

/**
 * 构建 value - label 一致的选框值
 * @param strArr string[]
 * @param sort boolean
 */
export const buildSelectorOptions = (strArr, sort = false) => {
  const arr = sort ? strArr.sort() : strArr;
  return arr.map(str => ({ label: str, value: str }));
};

/**
 * 视窗 resize
 */
export const windowResize = _throttle(cb => window.addEventListener('resize', cb));

/**
 * 异步执行 setTimeout
 */
export const asyncTimeout = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * 移除字符串中的空格、换行
 */
export const removeSpace = str =>
  str
    // eslint-disable-next-line no-useless-escape
    .replace(/\ /g, ' ')
    .replace(/\r\n/g, ' ')
    .replace(/\n/g, ' ');

/**
 * 获得只包含空格的 sql 语句
 */
export const simplifySql = sql =>
  sql
    // eslint-disable-next-line no-useless-escape
    .replace(/\ /g, ' ')
    .replace(/\r\n/g, ' ')
    .replace(/\n/g, ' ');

/**
 * 为 vue 路由添加 meta.databaseType 字段用于表示此路由属于哪种数据库
 * @param routes
 * @param type
 * @returns {*}
 */
export const setDatabaseType = (routes, type) => {
  return routes.map(route => {
    _set(route, 'meta.databaseType', type);
    if (route.children && route.children.length > 0) {
      route.children = setDatabaseType(route.children, type);
    }
    return route;
  });
};

/**
 * 秒钟数转天时分秒
 * @FIXME: 可优化
 */
export const secondToTime = originalSecond => {
  let totalSecond = Math.floor(originalSecond);
  let time = parseInt(totalSecond) + '秒';
  if (parseInt(totalSecond) > 60) {
    let second = parseInt(totalSecond) % 60;
    let min = parseInt(totalSecond / 60);
    time = min + '分 ' + second + '秒';

    if (min > 60) {
      min = parseInt(totalSecond / 60) % 60;
      let hour = parseInt(parseInt(totalSecond / 60) / 60);
      time = hour + '时 ' + min + '分 ' + second + '秒';

      if (hour > 24) {
        hour = parseInt(parseInt(totalSecond / 60) / 60) % 24;
        let day = parseInt(parseInt(parseInt(totalSecond / 60) / 60) / 24);
        time = day + '天 ' + hour + '时 ' + min + '分 ' + second + '秒';
      }
    }
  }

  return time;
};

/**
 * 判断字符串是否是 json 格式
 */
export const isJson = str => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

/**
 * 打开一个新的浏览器窗口
 * 如果直接使用 window.open，可以会被浏览器拦截
 */
export const openNewBrowserWindow = (url, id) => {
  if (document.querySelector(`#${id}`)) {
    document.body.removeChild(document.querySelector(`#${id}`));
  }

  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', id);
  document.body.appendChild(a);
  a.click();
};

/**
 * 为 vue 路由添加 meta.databaseType 字段用于表示此路由属于哪种数据库
 * @param routes
 * @param type
 * @returns {*}
 */
export const toLogin = (routes, sourceInfo) => {
  const { href } = routes.resolve({
    name: 'Login',
    query: {
      RegionId: sourceInfo.RegionId,
      instanceName: sourceInfo.instanceName,
      InstanceId: sourceInfo.InstanceId,
      ServicePort: sourceInfo.ServicePort,
      ServiceType: sourceInfo.instanceType
    }
  });
  sessionStorage.clear();
  Store.dispatch('tabs/clearTab');
  location.replace(href);
};
